export default __webpack_public_path__ + "assets/d6fe21852e811d4b2354b08ee848bd4c.jpg";